import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import Popup from "../components/PopUP";
import api from "../Api";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import GameBreadcrumb from "../components/GameBreadcrumb.js";
import {IMAGE_URL} from "../utils/constants";
import TableFooter from "../components/TableFooter";


const DesignHtml = () => {
  const [popupMessage, setPopupMessage] = useState("Loading page content...");

  const navigate = useNavigate();
  const { pathname } = useLocation();
  // const [loading, setLoading] = useState(true);
  const [endPoint, setEndPoint] = useState();
  const [allSets, setAllSets] = useState([]);  // full list from API (fetched once)
  // const [level, setLevel] = useState([]);
  // const [role, setRole] = useState([]);  
  // const [query, setQuery] = useState("");
  const [levelName, setLevelName] = useState();
  const [roleType, setRoleType] = useState();

  // --- local pagination ---
  const PAGE_SIZE = 20;
  const [currentPage, setCurrentPage] = useState(1);

  // Slice the full list to get only the current page's rows
  const sets = allSets.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  // Derive pagination metadata from local data
  const totalPages = Math.ceil(allSets.length / PAGE_SIZE);
  const pagination = {
    count: allSets.length,
    total_pages: totalPages,
    next: currentPage < totalPages ? currentPage + 1 : 0,
    previous: currentPage > 1 ? currentPage - 1 : 0
  };

  useEffect(() => {
    const fetchData = async () => {
      const pathParts = pathname.split("/").filter(Boolean);

      /*
        pathParts = [
          "game-management",
          "quiz-game",
          "1",
          "Aircraft%20Engineer"
        ]
      */
      setLevelName(sessionStorage.getItem("levelName"));

      const gameType = pathParts[1];
      const level = pathParts[2];
      // here role will going to be act as level for calculation.
      const role = decodeURIComponent(pathParts[3]).toLowerCase();
      setRoleType(decodeURIComponent(pathParts[3]));

      // setLevel(level);
      // setRole(role);

      // Resolve endpoint
      let endpoint = null;

      if (gameType === "quiz-game") {
        endpoint = "/quiz/";
      } else if (gameType === "one-word-game") {
        endpoint = "/one-word/";
      } else if (gameType === "calculation-game") {
        endpoint = "/calculation/";
      }

      if (!endpoint) return;

      setEndPoint(endpoint);

      // No page param – fetch all data at once for local pagination
      endpoint = `${endpoint}admin/sets?game_number=${level}`;
      if (gameType === "quiz-game") endpoint = `${endpoint}&user_role=${role}`;
      else if (gameType === "calculation-game" || gameType === "one-word-game")
        endpoint = `${endpoint}&level=${role}`;


      try {
        const apiUrl = endpoint;
        const response = await api.get(apiUrl);
        setAllSets(response.data.data);  // store full list locally
        setCurrentPage(1);               // reset to first page on new data
      } catch (error) {
        console.error("API Error:", error.message);
      }

      // setLoading(false);
    };

    fetchData();
  }, [pathname]);  // only re-fetch when the route changes, NOT on page change

  useEffect(() => {
    window.$('[data-toggle="tooltip"]').tooltip();
  }, [sets]);

  const goToQuestions = (id) => {
    navigate(`${id}`);
  };

  const handlePublish = async (setId) => {
    if (!endPoint) return;

    try {
      setPopupMessage("Publishing set...");

      const publishEndpoint = `${endPoint}admin/question-action`;
      const response = await api.patch(publishEndpoint, {
        set_id: setId,
        action: "approve"
      });

      if (response.status === 200 || response.status === 201) {
        setPopupMessage("Set published successfully!");

        // Update full list so local pagination stays in sync
        const updatedSets = allSets.map(set =>
          set.id === setId ? { ...set, is_approve: true } : set
        );
        setAllSets(updatedSets);
      }
    } catch (error) {
      console.error("API Error:", error.message);
      setPopupMessage(`Error publishing set: ${error.message}`);
    }
  };

  const handleReject = async (setId) => {
    if (!endPoint) return;

    try {
      setPopupMessage("Rejecting set...");

      const rejectEndpoint = `${endPoint}admin/question-action`;
      const response = await api.patch(rejectEndpoint, {
        set_id: setId,
        action: "reject"
      });

      if (response.status === 200 || response.status === 201) {
        setPopupMessage("Set rejected successfully!");

        // Update full list so local pagination stays in sync
        const updatedSets = allSets.map(set =>
          set.id === setId ? { ...set, is_approve: false } : set
        );
        setAllSets(updatedSets);
      }
    } catch (error) {
      console.error("API Error:", error.message);
      setPopupMessage(`Error rejecting set: ${error.message}`);
    }
  };


  return (
    <>
      <Popup message={popupMessage} onClose={() => setPopupMessage("")} />
      <Sidebar />
      <div className="main-wrapper">
        <Header />
        <div className="content-wrapper">
          <section className="main-section spacer-y">
            <div className="container">
              <div className="row gy-4">
                <div className="col-xl-12">
                  <div className="common_main_bg_wrapper">
                    <div className="common_main_heading_wrapper">
                      <div className="vstack">
                        <GameBreadcrumb quizId="" />

                        <h1 className="mb-2 mt-3">
                          Available Sets for {roleType} - {levelName}
                        </h1>
                      </div>
                    </div>
                  </div>

                  <div className="common-table-wrapper mt-4">
                    <div className="common-table-filter-wrapper">
                      <div className="common-left-blk">
                        <div className="common_sub_heading_wrapper mb-0">
                          <h2>Sets listing</h2>
                        </div>
                      </div>
                      {/* <div className="common-right-blk">
                        <div className="common-sort-blk">
                          <div className="common-search-blk">
                            <input
                              type="search"
                              className="form-control"
                              id="search"
                              value={query}
                              onChange={(e) => setQuery(e.target.value)}
                              placeholder="Search"
                            />
                          </div>
                        </div>
                      </div> */}
                    </div>

                    <div className="table-blk table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th>S.No</th>
                            <th>Set ID</th>
                            {/* <th>Title</th> */}
                            <th>Date Created</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sets.map((set, index) => (
                            <tr key={set.id}>
                              <td>{(index + 1) + (currentPage - 1) * 20}</td>
                              <td>{set.question_id}</td>
                              {/* <td className="text-capitalize">High-Altitude Navigation</td> */}
                              <td>{set.created_at}</td>
                              <td>
                                <span
                                  className={`td-status ${set.is_approve === true
                                    ? "st-active"
                                    : "st-inactive"
                                    } fw-semibold`}
                                >
                                  {set.is_approve === true
                                    ? "Published"
                                    : "Not Published"}
                                </span>
                              </td>
                              <td>
                                <span className="td-action">
                                  <button
                                    className="border-0 bg-white"
                                    onClick={() => {
                                      goToQuestions(set.id);
                                    }}
                                  >
                                    <img
                                      src={IMAGE_URL+"eye-tbl-icon.svg"}
                                      alt="View"
                                    />
                                  </button>

                                  <button
                                    type="button"
                                    className="border-0 bg-white"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Publish"
                                    onClick={() => handlePublish(set.id)}
                                    disabled={set.is_approve}
                                  >
                                    <i className="fa-solid fa-upload"></i>
                                  </button>

                                  <button
                                    type="button"
                                    className="border-0 bg-white"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                    title="Reject"
                                    onClick={() => handleReject(set.id)}
                                    disabled={!set.is_approve}
                                  >
                                    <i className="fa-solid fa-ban"></i>
                                  </button>
                                </span>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* footer */}
                    <TableFooter
                      pagination={pagination}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </>
  );
};

export default DesignHtml;
